<template>
  <div class="group-stage">
    <section>
      <h3 style="margin-bottom: 20px; color: #318bc9; font-size: 28px;">
        {{ $t("corporate.tournament_format") }}
      </h3>
      <transition name="el-fade-in-linear">
        <div>
          <div class="tab-header">
            <div
              v-for="(tab, index) in tabs"
              :key="index"
              :class="['tab', { active: activeTab === tab.id }]"
              @click="changeTab(tab.id)"
            >
            {{ $t('corporate.' + tab.label) }}
            </div>
          </div>
          <div class="tab-content">
            <div class="active-tab" v-if="activeTab === '1'">
              <el-table 
                :data="tableDataMen1"
                :span-method="arraySpanMethodFormat"
                border
                style="width: 100%;margin-bottom : 30px; "
                :header-cell-style="tournamentTableHeaderStyle"
                :cell-style="tournamentTableCellStyle"
                :row-style="tournamentTableRowStyle"
              >
                <el-table-column
                  prop="tableCategory"
                  :min-width="120"
                  style="border-color: #95cedd;"
                >
                  <template slot-scope="scope">
                    <strong><span v-html="scope.row.tableCategory"></span></strong>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="description"
                  :min-width="160"
                  style="border-color: #95cedd;"
                >
                  <template slot-scope="scope">
                    <p v-html="scope.row.description"></p>
                  </template>
                </el-table-column>
              </el-table>

              <el-table
                :data="tableData1"
                border
                style="width: 100%;margin-bottom : 30px; "
                :header-cell-style="groupStageTableHeaderStyle"
                :cell-style="groupStageTableCellStyle"
                :row-style="groupStageTableRowStyle"
              >
                <el-table-column
                  prop="tableCategory"
                  label=""
                  :min-width="120"
                  style="border-color: #95cedd;"
                >
                  <template slot-scope="scope">
                    <strong><span v-html="scope.row.tableCategory"></span></strong>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="group"
                  :label="getLabel('group')"
                  :min-width="160"
                  style="border-color: #95cedd;"
                >
                  <template slot-scope="scope">
                    <p v-html="scope.row.group"></p>
                  </template>
                </el-table-column>
                <el-table-column
                  type="String"
                  prop="finals"
                  :label="getLabel('finals')"
                  :min-width="160"
                  style="border-color: #95cedd;"
                  align="center"
                >
                  <template slot-scope="scope">
                    <p v-html="scope.row.finals"></p>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="active-tab" v-if="activeTab === '2'">
              <el-table 
                :data="tableDataMen2"
                :span-method="arraySpanMethodFormat"
                border
                style="width: 100%;margin-bottom : 30px; "
                :header-cell-style="tournamentTableHeaderStyle"
                :cell-style="tournamentTableCellStyle"
                :row-style="tournamentTableRowStyle"
              >
                <el-table-column
                  prop="tableCategory"
                  :min-width="120"
                  style="border-color: #95cedd;"
                >
                  <template slot-scope="scope">
                    <strong><span v-html="scope.row.tableCategory"></span></strong>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="description"
                  :min-width="160"
                  style="border-color: #95cedd;"
                >
                  <template slot-scope="scope">
                    <p v-html="scope.row.description"></p>
                  </template>
                </el-table-column>
              </el-table>

              <el-table
                :data="tableData2"
                border
                style="width: 100%;margin-bottom : 30px; "
                :span-method="arraySpanMethod"
                :header-cell-style="groupStageTableHeaderStyle"
                :cell-style="groupStageTableCellStyle"
                :row-style="groupStageTableRowStyle"
              >
                <el-table-column
                  prop="tableCategory"
                  label=""
                  :min-width="120"
                  style="border-color: #95cedd;"
                >
                  <template slot-scope="scope">
                    <strong><span v-html="scope.row.tableCategory"></span></strong>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="group"
                  :label="getLabel('group')"
                  :min-width="160"
                  style="border-color: #95cedd;"
                >
                  <template slot-scope="scope">
                    <p v-html="scope.row.group"></p>
                  </template>
                </el-table-column>
                <el-table-column
                  type="String"
                  prop="finals"
                  :label="getLabel('finals')"
                  :min-width="160"
                  style="border-color: #95cedd;"
                  align="center"
                >
                  <template slot-scope="scope">
                    <p v-html="scope.row.finals"></p>
                  </template>
                </el-table-column>
                <el-table-column
                  type="String"
                  prop="tournament"
                  :label="getLabel('tournament')"
                  :min-width="160"
                  style="border-color: #95cedd;"
                >
                  <template slot-scope="scope">
                    <p v-html="scope.row.tournament"></p>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </transition>
      <div class="download-link">
        <div class="link-container">
          <a
            class="download_link"
            href="https://drive.google.com/file/d/18xLqCTJbphL1J1OX03jTpu4JdPgZ3GVY/view"
            style="color: #318bc9; font-size: 28px; font-weight: bolder;"
            >{{ $t("corporate.download_pack") }}</a
          >
          <img src="../../../assets/finger_pointer.png" />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  props: ["teams", "tabnames", "activeNametab", "tabid"],
  data() {
    return {
      mobile: false,
      screenWidth: document.body.clientWidth,
      activeName: "",
      tableData1: [
        {
          // translating language based on stored locale value, if you know more efficient way, change this.
          tableCategory:
            localStorage.getItem("locale") === "en" ? "Teams" : "隊伍",
          group:
            localStorage.getItem("locale") === "en"
              ? "<b>All teams</b><br>20 (4 Groups x 5 Teams)"
              : "<b>全部隊伍</b><br>20 (4 組 x 5 隊)",
          finals:
            localStorage.getItem("locale") === "en"
              ? "<b>Top 2 Teams from each Group</b><br>8 (4 Groups x 2 Temas)<br>Ranking 1-4: Gold Cup<br>Ranking 5-8: Gold Plate"
              : "<b>各小組首2名</b><br>8 (4 組 x 2 隊)<br>第1至4名：金盃賽<br>第5至8名：金碟賽"
        },
        {
          tableCategory:
            localStorage.getItem("locale") === "en" ? "Format" : "賽制",
          group:
            localStorage.getItem("locale") === "en"
              ? "Single round-robin"
              : "單循環制",
          finals:
            localStorage.getItem("locale") === "en"
              ? "Single elimination"
              : "單淘汰制"
        },
        {
          tableCategory:
            localStorage.getItem("locale") === "en" ?  `No. of Game <br> <span style="font-size: 12px">(each team)</span>` : "每隊比賽場數",
          group: "4",
          finals: "3"
        },
        {
          tableCategory:
            localStorage.getItem("locale") === "en" ? "Date & Time" : "日期及時間",
          group:
            localStorage.getItem("locale") === "en"
              ? "<b>July</b> <br> 23-25 (19:00-22:00)"
              : "<b>7月</b> <br> 23-25 (19:00-22:00)",
          finals:
            localStorage.getItem("locale") === "en"
              ? "<b>August</b> <br> 30 (10:00-18:00)"
              : "<b>8月</b> <br> 30 (10:00-18:00)"
        },
        {
          tableCategory:
            localStorage.getItem("locale") === "en" ? "Location" : "地點",
          group:
            localStorage.getItem("locale") === "en"
              ? "Christian Alliance International School<br>(Lai Chi Kok)"
              : "宣道國際學校<br>（荔枝角）",
          finals:
            localStorage.getItem("locale") === "en"
              ? "Kai Yip Recreation Centre<br>(The Rooftop of the Kai Yip Shopping Centre Car Park)"
              : "啟業運動場<br>（啟業商場停車場天台）"
        }
      ],

      tableData2: [
        {
          // translating language based on stored locale value, if you know more efficient way, change this.
          tableCategory:
            localStorage.getItem("locale") === "en" ? "Teams" : "隊伍",
          group:
            localStorage.getItem("locale") === "en"
              ? "<b>All teams</b><br>40 (8 Groups x 5 Teams)"
              : "<b>全部隊伍</b><br>40 (8 組 x 5 隊)",
          finals:
            localStorage.getItem("locale") === "en"
              ? "<b>Top 3 Teams from each Group</b><br>8 (4 Groups x 2 Temas)<br>Ranking 1-8: Gold Tournament<br>Ranking 9-16: Silver Tournament"
              : "<b>各小組首2名</b><br>8 (4 組 x 2 隊)<br>第1至8名：金賽<br>第9至16名：銀賽",
          tournament:
            localStorage.getItem("locale") === "en"
              ? "<b>Gold Tournament</b><br>Ranking 1-4: Gold Cup<br>Ranking 5-8: Gold Plate<br><b>Silver Tournament</b><br>Ranking 1-4: Silver Cup<br>Ranking 5-8: Silver Plate"
              : "<b>金賽：</b><br>第1至4名：金盃賽<br>第5至8名：金碟賽<br><br><b>銀賽：</b><br>第1至4名：銀盃賽<br>第5至8名：銀碟賽"
        },
        {
          tableCategory:
            localStorage.getItem("locale") === "en" ? "Format" : "賽制",
          group:
            localStorage.getItem("locale") === "en"
              ? "Single round-robin"
              : "單循環制",
          finals:
            localStorage.getItem("locale") === "en"
              ? "Single elimination "
              : "單淘汰制"
        },
        {
          tableCategory:
            localStorage.getItem("locale") === "en" ?  `No. of Game <br> <span style="font-size: 12px">(each team)</span>` : "每隊比賽場數",
          group: "4",
          finals: "4"
        },
        {
          tableCategory:
            localStorage.getItem("locale") === "en" ? "Date & Time" : "日期及時間",
          group:
            localStorage.getItem("locale") === "en"
              ? "<b>July</b> <br> 23-25 (19:00-22:00)"
              : "<b>7月</b> <br> 23-25 (19:00-22:00)",
          finals:
            localStorage.getItem("locale") === "en"
              ? "<b>August</b> <br> 30 (10:00-18:00)"
              : "<b>8月</b> <br> 30 (10:00-18:00)"
        },
        {
          tableCategory:
            localStorage.getItem("locale") === "en" ? "Location" : "地點",
          group:
            localStorage.getItem("locale") === "en"
              ? "Christian Alliance International School<br>(Lai Chi Kok)"
              : "宣道國際學校<br>（荔枝角）",
          finals:
            localStorage.getItem("locale") === "en"
              ? "Kai Yip Recreation Centre<br>(The Rooftop of the Kai Yip Shopping Centre Car Park)"
              : "啟業運動場<br>（啟業商場停車場天台）"
        }
      ],

      tableDataMen1: [
        {
          tableCategory:
            localStorage.getItem("locale") === "en" ? "No. of Teams" : "球隊數目",
          description: `<div style="display: flex; flex-direction: row; justify-items: center; padding: 10px 0px;"> <b style='font-size: 50px; margin-right: 10px;'>20</b> ${
            localStorage.getItem("locale") === "en"
              ? "(4 Groups x 5 Teams)"
              : "(4 組 x 5 隊)"
          } </div>`
        },
        {
          tableCategory:
            localStorage.getItem("locale") === "en" ? "Game Rules" : "比賽規則",
          description: `
            <style>
                ul {
                    list-style-type: disc;
                }
                .fiba-rules li {
                    padding-left: 50px;
                }
            </style> ${
              localStorage.getItem("locale") === "en" ? `
              To follow the FIBA Official 3x3 Basketball Rules, besides:<br><br>
                <ul class="fiba-rules">
                    <li>Each team can have a total of 40 participants, including players, coach(es), supporters, etc.;</li><br>
                    <li>Teams are allowed to have coach(es) leading;</li><br>
                    <li>Teams are not required to submit player roster and substitution is unlimited;</li><br>
                    <li>Clock will be stopped in the last minute of the game and time-outs only;</li><br>
                    <li>Each team will have one 20-second time-out every game.</li>
                </ul>
                `
                : `
                    將根據國際籃球聯會3x3比賽規則比賽，除此之外：<br><br>
                    <ul class="fiba-rules">
                    <li> 每隊可安排40名參加者，包括球員、教練、支持者等;</li><br>
                    <li> 參賽隊伍容許有教練帶隊;</li><br>
                    <li> 隊伍無須提交球員名單，換人次數不限;</li><br>
                    <li> 只有暫停及比賽最後1分鐘會停錶;</li><br>
                    <li> 每隊每場有一次20秒暫停。</li>
                    </ul>
                  `
            }`
        },
        {
          tableCategory:
            localStorage.getItem("locale") === "en"
              ? "Special Rules"
              : "特殊規則",
          description:
            localStorage.getItem("locale") === "en"
              ? `
                <ul>
                  <li>No current HKBA A1 and A2 Division (both league & Silver Shield) or Hong Kong Basketball Team players allowed to be on the court;</li><br>
                  <li>Current WELL DUNK! team title-sponsors can request one student from their sponsored team to play for their team.</li>
                </ul>
                    `
              : `
                  現役香港代表隊成員、香港籃球聯賽男子甲一、甲二組別的球員，不得落場參與比賽；<br>
                  現屆《邨JUMP！》球隊贊助商可要求一名其《邨JUMP！》球隊的學員擔任外援。
              `
        },
        {
          tableCategory:
            localStorage.getItem("locale") === "en" ? "Awards" : "獎項",
          description:
            localStorage.getItem("locale") === "en"
              ? `
                  8 Awards<br>
                  Champion & 1st to 3rd runner-up of Gold Cup, Gold Plate
              `
              : `
                  8 個獎項<br>
                  金盃、金碟、銀盃、銀碟各設冠、亞、季、殿軍
              `
        }
      ],

      tableDataMen2: [
        {
          tableCategory:
            localStorage.getItem("locale") === "en" ? "No. of Teams" : "球隊數目",
          description: `<div style="display: flex; flex-direction: row; justify-items: center; padding: 10px 0px;"> <b style='font-size: 50px; margin-right: 10px;'>40</b> ${
            localStorage.getItem("locale") === "en"
              ? "(8 Groups x 5 Teams)"
              : "(8 組 x 5 隊)"
          } </div>`
        },
        {
          tableCategory:
            localStorage.getItem("locale") === "en" ? "Game Rules" : "比賽規則",
          description: `<style>
                ul {
                    list-style-type: disc;
                }

                .fiba-rules li {
                    padding-left: 50px;
                }
            </style> ${
              localStorage.getItem("locale") === "en" ? `

              To follow the FIBA Official 3x3 Basketball Rules, besides:<br><br>
                <ul class="fiba-rules">
                    <li>Each team can have a total of 40 participants, including players, coach(es), supporters, etc.;</li><br>
                    <li>Teams are allowed to have coach(es) leading;</li><br>
                    <li>Teams are not required to submit player roster and substitution is unlimited;</li><br>
                    <li>Clock will be stopped in the last minute of the game and time-outs only;</li><br>
                    <li>Each team will have one 20-second time-out every game.</li>
                </ul>
                `
                : `
                    將根據國際籃球聯會3x3比賽規則比賽，除此之外：<br><br>
                    <ul class="fiba-rules">
                      <li> 每隊可安排40名參加者，包括球員、教練、支持者等;</li><br>
                      <li> 參賽隊伍容許有教練帶隊;</li><br>
                      <li> 隊伍無須提交球員名單，換人次數不限;</li><br>
                      <li> 只有暫停及比賽最後1分鐘會停錶;</li><br>
                      <li> 每隊每場有一次20秒暫停。</li>
                    </ul>
                  `
            }`
        },
        {
          tableCategory:
            localStorage.getItem("locale") === "en"
              ? "Special Rules"
              : "特殊規則",
          description:
            localStorage.getItem("locale") === "en"
              ? `
                <ul>
                  <li>No current HKBA A1 and A2 Division (both league & Silver Shield) or Hong Kong Basketball Team players allowed to be on the court;</li><br>
                  <li>Current WELL DUNK! team title-sponsors can request one student from their sponsored team to play for their team.</li>
                </ul>
                    `
              : `
                  現役香港代表隊成員、香港籃球聯賽男子甲一、甲二組別及女子甲組的球員，不得落場參與比賽；<br>
                  現屆《邨JUMP！》球隊贊助商可要求一名其《邨JUMP！》球隊的學員擔任外援。
              `
        },
        {
          tableCategory:
            localStorage.getItem("locale") === "en" ? "Awards" : "獎項",
          description:
            localStorage.getItem("locale") === "en"
              ? `
                  16 Awards<br>
                  Champion & 1st to 3rd runners-up of Gold Cup, Gold Plate, Silver Cup, Silver Plate
              `
              : `
                  16 個獎項<br>
                  金盃、金碟、銀盃、銀碟各設冠、亞、季、殿軍
              `
        }
      ],

      keyFiguresData: [
        {
          tableCategory:
            localStorage.getItem("locale") === "en"
              ? "Participating Teams"
              : "參賽隊伍",
          icon: "el-icon-user-solid",
          year2020: "12",
          year2021: "20",
          year2022: "45",
          year2023:
            localStorage.getItem("locale") === "en"
              ? "50 - 100 teams"
              : "50 - 100 隊"
        },
        {
          tableCategory:
            localStorage.getItem("locale") === "en"
              ? "Total No. of Participants"
              : "總參與人數",
          icon: "el-icon-user-solid",
          year2020: "~ 200",
          year2021: "> 400",
          year2022: "> 900",
          year2023: "> 1500"
        },
        {
          tableCategory:
            localStorage.getItem("locale") === "en"
              ? "Days of Competition"
              : "比賽日數",
          icon: "el-icon-date",
          year2020: "0.5",
          year2021: "2",
          year2022: "4",
          year2023:
            localStorage.getItem("locale") === "en"
              ? "6 half days<br>3 full days<br>ALL in Southorn Stadium"
              : "6個 半天比賽日<br>3個 半天比賽日<br>全部於修頓室內場館進行"
        },
        {
          tableCategory:
            localStorage.getItem("locale") === "en"
              ? "Total No. of Competitions"
              : "總比賽數目",
          icon: "el-icon-trophy",
          year2020: "12",
          year2021: "44",
          year2022: "150",
          year2023:
            localStorage.getItem("locale") === "en"
              ? "Up to <strong>260</strong> matches"
              : "多達260場比賽"
        }
      ],

      key: [
        {
          date_2020: "table_one_content1_1_2020",
          date_2021: "table_one_content1_1_2021",
          date_2022: "table_one_content1_1_2022",
          date_2023: "table_one_content1_1_2023",
          name: "table_one_name1",
          icon: "el-icon-user-solid"
        },
        {
          date_2020: "table_one_content2_1_2020",
          date_2021: "table_one_content2_1_2021",
          date_2022: "table_one_content2_1_2022",
          date_2023: "table_one_content2_1_2023",
          name: "table_one_name2",
          icon: "el-icon-date"
        },
        {
          date_2020: "table_one_content3_1_2020",
          date_2021: "table_one_content3_1_2021",
          date_2022: "table_one_content3_1_2022",
          date_2023: "table_one_content3_1_2023",
          name: "table_one_name3",
          icon: "el-icon-trophy"
        },
        {
          date_2020: "table_one_content4_1_2020",
          date_2021: "table_one_content4_1_2021",
          date_2022: "table_one_content4_1_2022",
          date_2023: "table_one_content4_1_2023",
          name: "table_one_name4",
          icon: "el-icon-s-order"
        }
      ],
      Nutshell: [
        {
          group: "table_two_content1_1",
          playOff: "table_two_content1_2",
          name: "",
          finals: "table_two_content1_3",
          finals_right: ""
        },
        {
          group: "table_two_content2_1",
          playOff: "table_two_content2_2",
          name: "",
          finals: "table_two_content2_3",
          finals_right: ""
        },
        {
          group: "table_two_content3_1",
          playOff: "table_two_content3_2",
          name: "",
          finals: "table_two_content3_3",
          finals_right: ""
        },
        {
          group: "table_two_content4_1",
          playOff: "table_two_content4_2",
          name: "table_two_name1",
          finals: "table_two_content4_3",
          finals_right: "table_two_content4_4"
        },
        {
          group: "table_two_content5_1",
          playOff: "table_two_content5_2",
          name: "table_two_name2",
          finals: "table_two_content5_3",
          finals_right: "table_two_content5_4"
        },
        {
          group: "table_two_content6_1",
          playOff: "",
          name: "",
          finals: "",
          finals_right: ""
        },
        {
          group: "table_two_content7_1",
          playOff: "",
          name: "table_two_name3",
          finals: "",
          finals_right: "table_two_content7_4"
        },
        {
          group: "table_two_content8_1",
          playOff: "",
          name: "table_two_name4",
          finals: "",
          finals_right: ""
        }
      ],
      tabs: [
        {
          id: "1",
          label: "men_tournament"
        },
        {
          id: "2",
          label: "mixed_tournament"
        }
      ],
      activeTab: "1"
    };
  },
  watch: {
    activeNametab() {
      this.activeName = this.activeNametab;
    },
    screenWidth(val) {
      this.screenWidth = val;
    }
  },
  mounted() {
    // this.populateCorporateData();
    const that = this;
    //当进入页面监听
    that.isMobile();
    // 事件监听滚动条
    window.onresize = () => {
      return (() => {
        that.isMobile();
      })();
    };
  },
  methods: {
    isMobile() {
      window.screenWidth = document.body.clientWidth;
      this.screenWidth = window.screenWidth;
      if (this.screenWidth < 500) {
        this.mobile = true;
      } else {
        this.mobile = false;
      }
    },
    handleClick(tab) {
      this.$emit("handleDateChange", tab.name);
    },
    // merging table columnn
    arraySpanMethod({ rowIndex, columnIndex }) {
      if ([1, 2, 3, 4].includes(rowIndex)) {
        if (columnIndex === 2) {
          return [1, 2];
        }
      }
    },
    arraySpanMethodFormat({ rowIndex, columnIndex }) {
      return [1, 1];
    },
    getLabel(type) {
      if (type === "group") {
        return localStorage.getItem("locale") === "en"
          ? "Group Stage"
          : "小組賽";
      } else if (type === "tournament") {
        return localStorage.getItem("locale") === "en"
          ? "Gold/ Silver Tournament"
          : "金賽 / 銀賽";
      }
      return localStorage.getItem("locale") === "en" ? "Finals" : "決賽";
    },
    groupStageTableHeaderStyle({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) return "background-color: #ffffff; border-top: 2px solid #318BC8; border-bottom: 1px solid #318BC8; border-color: #318BC8;";
    },
    groupStageTableRowStyle({ row, rowIndex }) {
      // https://blog.csdn.net/ww_5211314/article/details/109615099
      // Returning a styleJson is required based on ElementUI doc
      let json = {};
      if (rowIndex % 2 === 0) {
        json.backgroundColor = "#d0e4f4";
      } else {
        json.backgroundColor = "#a8d4e4";
      }
      if (rowIndex === 2) {
        json.fontWeight = "800";
      }
      return json;
    },
    groupStageTableCellStyle({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 2 && columnIndex != 0) {
        return "background-color: #ffffff; border-color: #318BC8; font-weight: normal";
      } else if (columnIndex === 0) {
        return "background-color: #ffffff; border-color: #318BC8";
      } else if (rowIndex % 2 === 0) {
        return "background-color: #ffffff; border-color: #318BC8";
      } else {
        return "background-color: #ffffff; border-color: #318BC8";
      }
    },
    tournamentTableHeaderStyle({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) return "display: none;";
    },
    tournamentTableRowStyle({ row, rowIndex }) {
      // https://blog.csdn.net/ww_5211314/article/details/109615099
      // Returning a styleJson is required based on ElementUI doc
      let json = {};
      if (rowIndex % 2 === 0) {
        json.backgroundColor = "#d0e4f4";
      } else {
        json.backgroundColor = "#a8d4e4";
      }
      // if (rowIndex === 2) {
      //   json.fontWeight = "800";
      // }
      return json;
    },
    tournamentTableCellStyle({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 2 && columnIndex != 0) {
        return "background-color: #fff; border-color: #318BC8; text-align: left !important; padding-left: 20px; font-weight: 900";
      } else if (columnIndex === 0) {
        return `background-color: #fff; border-color: #318BC8; `;
      } else if (rowIndex % 2 === 0) {
        return "background-color: #fff; border-color: #318BC8; text-align: left !important; padding-left: 20px";
      } else {
        return "background-color: #fff; border-color: #318BC8; text-align: left !important; padding-left: 20px";
      }
    },
    getDataTable(key) {
      return key ? this.$t(`scheme_intro.${key}`) : '';
    },
    changeTab(id) {
      (this.type = id), (this.activeTab = id);
    }
  }
};
</script>
<style lang="scss" scoped>
.group-stage {
  .text-intro {
    padding: 20px;
    line-height: 1.7;
  }

  section {
    padding: 20px;
    text-align: left;
    height: auto;
    width: 100%;
    justify-content: center;

    .download-link{
      text-align: center;

      .link-container {
        display: inline-flex;
        gap: 5px;
        padding: 20px;
        align-items: center;
        border-radius: 8px;

        a,
        a:active,
        a:focus,
        a:visited {
          color: #318bc9;
          text-decoration: none;
        }
        background-color: white;
        .download_link {
          text-decoration: none;
          font-size: 28px;
        }
        img {
          width: 30px;
          height: 30px;
        }
      }
      .link-container:hover {
        background-color: #8da9db;
        a,
        a:active,
        a:focus,
        a:visited {
          color: white;
          text-decoration: none;
        }
      }
    }

    .table-note {
      margin: 48px 0px;

      .note-content {
        padding-left: 16px;
      }
    }

    .groupStageSignUpNow {
      margin: 0 auto;
      text-align: center;
      padding: 10px 0px;

      p {
        font-weight: bold;
        font-size: 18px;
      }

      .groupStageSignUpNowLink {
        padding: 8px 20px 8px 20px;
        border-radius: 20px;
        background-color: white;
        display: inline-flex;
        font-size: 2rem;
        border: 3px solid #8da9db;
        display: table;
        margin: 10px auto 30px auto;

        a,
        a:active,
        a:focus,
        a:visited {
          color: black;
          text-decoration: none;
          padding: 10px;
        }
      }

      .groupStageSignUpNowLink:hover {
        background-color: #8da9db;
        a:active,
        a:focus,
        a:visited {
          color: #fff;
        }
      }
      .groupStageSignUpNowText {
        margin-top: 2rem;
        font-size: 18px;
        font-weight: bold;

        p{
          padding-bottom: 10px;
        }
      }
    }

    // grid style
    .features-row {
      height: 100px;
      display: flex;
      align-items: center;
      border: 1px solid black;
      // overriding element plus col offset

      .grid-content {
        padding: 20px;
        h2 {
          font-size: 1.3em;
          font-weight: normal;

          @media screen and (max-width: 920px) {
            font-size: 0.7rem;
          }
        }
      }

      .border-col {
        height: 100%;
        width: 2px;
        background-color: black;
      }

      @media screen and (max-width: 650px) {
        .arrow-img {
          display: none;
        }
      }

      @media screen and (max-width: 850px) {
        .arrow-img {
          img {
            width: 20px;
            height: 20px;
          }
        }
      }
    }
    // nutshell style
    .tables {
      width: 100%;

      .nutshell {
        width: 100%;

        .table {
          border-collapse: collapse;
          width: 100%;

          tbody {
            tr {
              td {
                height: 50px;
                padding: 10px 20px;
                transition: all 0.2s;
              }

              .first-part-header {
                background-color: aliceblue;
              }

              .second-part-header {
                background-color: ivory;
              }

              .first-part {
                text-align: left;
                background-color: aliceblue;
                position: relative;
                width: 30%;
              }

              .first-part::after {
                content: "";
                position: absolute;
                margin: auto;
                right: 0;
                bottom: 0;
                left: 0;
                width: 90%;
                height: 1px;
                background-color: #b8dcff;
              }

              .second-part {
                text-align: left;
                background-color: ivory;
                position: relative;
                width: 30%;
              }

              .second-part::after {
                content: "";
                position: absolute;
                margin: auto;
                right: 0;
                bottom: 0;
                left: 0;
                width: 90%;
                height: 1px;
                background-color: #ffe4a8;
              }

              .first-part-bottom {
                background-color: aliceblue;
              }

              .second-part-bottom {
                background-color: ivory;
              }

              .game-rules {
                position: absolute;
                margin-top: -6.8%;
                padding-right: 60px;

                div:first-child {
                  width: 20%;
                  display: table-cell;
                }

                div:last-child {
                  width: 70%;
                  display: table-cell;
                }

                .red-text-game {
                  color: red;
                  font-weight: 700;
                  font-size: 1.4rem;
                }
              }
            }
          }
        }
      }
    }
    // reserve section
    .reserve {
      display: flex;
      width: 100%;
      margin-top: 40px;
      justify-content: space-between;

      .res-left,
      .res-right {
        width: 48%;
        box-shadow: 2px 2px 5px;
        border-radius: 20px;
      }

      .res-left {
        padding: 15px;

        .icon {
          .el-icon-s-management {
            font-size: 50px;
            padding: 15px;
            color: #a8d46f;
            border-radius: 50%;
            overflow: hidden;
            background: #ececf0;
          }
        }

        .download {
          // margin-top: 15px;
          // padding: 10px;

          a {
            color: #a8d46f;
          }
        }
      }

      .res-right {
        display: flex;
        align-content: center;
        justify-content: center;
        align-items: center;

        a {
          color: #a8d46f;
        }
      }
    }
  }
  .tab-header {
    display: flex;
    flex-direction: row;
  }

  .tab {
    padding: 10px 20px;
    cursor: pointer;
  }

  .active {
    background-color: #ccc;
  }

  .tab-content {
    margin-top: 20px;
    width: 100%;
  }

  .active-tab {
    width: 100%;
  }

  .el-table {
    border-top: 2px solid #318BC8;
    border-bottom: 3px solid #318BC8;
    border-left: 2px solid #318BC8;
    border-right: 2px solid #318BC8;
    border-color: #318BC8 !important;
  }
}
</style>
<style lang="scss">
/* style the table here in case you need it */
.groupStageKeyFigures {
  .el-table td,
  .el-table th.is-leaf {
    border-top: 2px solid #318BC8;
    border-bottom: 1px solid #318BC8;
  }

  .el-table--border th,
  .el-table--border th.gutter:last-of-type {
    border-top: 2px solid #318BC8;
    border-bottom: 1px solid #318BC8 !important;
  }

  .el-table--border td,
  .el-table--border th {
    border-top: 2px solid #318BC8;
    border-bottom: 1px solid #318BC8;
  }

  .el-table_2_column_5:not(th) {
    border-right: 1px solid #318BC8 !important;
  }
}
</style>
